export function getView(is_secure) {
  return is_secure ? 'Secure' : 'NotSecure'
}
